import {Component, Input, OnInit} from '@angular/core';
import hljs from 'highlight.js/lib/core';
import json from 'highlight.js/lib/languages/json';
import xml from 'highlight.js/lib/languages/xml';

@Component({
  selector: 'response-body',
  templateUrl: './response-body.component.html',
  styleUrls: ['./response-body.component.scss', '../response-display.scss']
})
export class ResponseBodyComponent implements OnInit {

  @Input() requestBody;
  @Input() headers;
  contentType: string;

  constructor() { }

  ngOnInit(): void {
    hljs.registerLanguage('json', json);
    hljs.registerLanguage('xml', xml);
    this.contentType = this.getContentType(this.headers);
  }

  getContentType(headers): string {
    if (headers) {
      const contentTypeHeader = headers.find(header => header.key && (header.key.toLowerCase() === 'content-type'));
      if (contentTypeHeader) {
        const contentType = contentTypeHeader.value.toLowerCase();
        if (contentType === 'application/json') {
          return 'json';
        } else if (contentType === 'application/xml') {
          return 'xml';
        } else if (contentType === 'multipart/form-data') {
          return 'form-data';
        } else if (contentType === 'application/x-www-form-urlencoded') {
          return 'form-urlencoded';
        }
      }
    }
    return 'unknown';
  }

  getJsonvalue(value) {
    if (value) {
      try {
        const jsonString = JSON.stringify(value, null, 2);
        return hljs.highlight('json', jsonString).value;
      } catch {
        return value;
      }
    }
    return '';
  }

  getXMLvalue(value) {
    if (value) {
      try {
        const xmlString = value;
        return hljs.highlight('xml', xmlString).value;
      } catch {
        return value;
      }
    }
    return '';
  }
}
